import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { CompanyProfileAPI } from "api";
import { baseURL } from "api/Base";

const CompanyProfileContext = createContext(null);

const initialState = {
  isLoading: true,
  data: null,
  error: null,
};

export const CompanyProfileProvider = ({ children }) => {
  const [state, setState] = useState(initialState);

  const fetchData = async () => {
    try {
      setState((prev) => ({
        ...prev,
        isLoading: true,
        error: null,
      }));

      const res = await CompanyProfileAPI.get();

      const company = res?.data?.data?.[0] || null;
      console.log(company);

      if (company?.name) {
        document.title = company.name;
      }

      // ✅ Update favicon
      if (company?.favicon) {
        let favicon = document.querySelector("link[rel='icon']");

        if (!favicon) {
          favicon = document.createElement("link");
          favicon.rel = "shortcut icon";
          document.head.appendChild(favicon);
        }

        favicon.href = `${baseURL}${company.favicon}`;
      }

      setState({
        isLoading: false,
        data: res?.data?.data[0] || null,
        error: null,
      });
    } catch (error) {
      setState({
        isLoading: false,
        data: null,
        error,
      });
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const value = useMemo(
    () => ({
      ...state,
      refresh: fetchData,
    }),
    [state],
  );

  return (
    <CompanyProfileContext.Provider value={value}>
      {children}
    </CompanyProfileContext.Provider>
  );
};

export const useCompanyProfile = () => {
  const context = useContext(CompanyProfileContext);

  if (!context) {
    throw new Error(
      "useCompanyProfile must be used within CompanyProfileProvider",
    );
  }

  return context;
};
